<p
  nz-typography
  [nzContent]="text"
  nzEllipsis
  [nzEllipsisRows]="ellipsisRows"
  [ngStyle]="{ 'font-size': fontSize }"
></p>

<ng-template #tooltipRef>
  <p class="text-tooltip">
    {{ text }}
  </p>
</ng-template>
